import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export const authSlice = createSlice({
  name: "auth",
  initialState: { user: null, token: null },
  reducers: {
    setCredentials: (state, action) => {
      //   state.isOpen = !state.isOpen;
      const { user, accessToken } = action.payload
      state.user = user
      state.token = accessToken
    },
    logOut: (state, action) => {            
      state.user = null
      state.token = null 
    },
  },
  extraReducers: (builder) => { },
});

// Action creators are generated for each case reducer function
export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state:any) => state.auth.user
export const selectCurrentToken = (state:any) => state.auth.token